<app-toast *ngIf="!(hideToast$ | async)"></app-toast>
<router-outlet></router-outlet>
<app-loading-overlay></app-loading-overlay>